import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref } from "vue";
import BaseChip from "@/components-UI/BaseChip.vue";

interface Props {
    value: string | string[]
    isMultiple?: boolean
    isDisabled?: boolean
    isUnderline?: boolean
    height?: number
    maxItems?: number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseCombobox',
  props: {
    value: null,
    isMultiple: { type: Boolean },
    isDisabled: { type: Boolean },
    isUnderline: { type: Boolean },
    height: null,
    maxItems: null
  },
  emits: ['update:value'],
  setup(__props: any, { emit }) {

const props = __props as {
    value: string | string[]
    isMultiple?: boolean
    isDisabled?: boolean
    isUnderline?: boolean
    height?: number
    maxItems?: number;
}




const items = ref<string[]>([]);
const inputValue = ref<string>('');
const isShowDropdown = ref<boolean>(false);

const getStyle = computed(() => {
    if (props.height === undefined || props.height === null) {
        return {};
    }
    return { minHeight: `${props.height}px` };
});

const getClasses = computed(() => {
    const classes = {
        '--underline': props.isUnderline,
        '--disabled': props.isDisabled,
    };
    return Object.keys(classes).filter((key) => classes[key]);
});

onMounted(() => {
    validateValue();
});

const validateValue = () => {
    if (Array.isArray(props.value)) {
        const val = props.value.filter(Boolean);
        emit('update:value', val);
    }
};

const addItem = () => {
    if (!inputValue.value) return;
    addItemHandler();
};

const addItemHandler = (item: string = inputValue.value) => {
    if (props.isMultiple) {
        addItemToValue(item);
    } else {
        emit('update:value', inputValue.value);
        inputValue.value = '';
    }
};

const addItemToValue = (item: string): void => {
    const isChecked = props.value.includes(item);
    if (isChecked) return;
    const isExist = items.value.includes(item);
    if (!isExist) items.value.push(item);
    const val = [...props.value, item];
    emit('update:value', val);
    inputValue.value = '';
};

const deleteSelectedItem = (item: string): void => {
    if (!props.isMultiple) {
        emit('update:value', '');
        return;
    }
    if (!Array.isArray(props.value)) return;
    const index = props.value.findIndex(i => i === item);
    if (index < 0) return;
    const val = [...props.value];
    val.splice(index, 1);
    emit('update:value', val);

    if (val.length === 0) {
        closeDropdown();
    }
};

const toggleDropdown = () => {
    isShowDropdown.value = !isShowDropdown.value;
};

const blurInput = () => {
    addItem();
};

const closeDropdown = () => {
    isShowDropdown.value = false;
};

return { __sfc: true,props, emit, items, inputValue, isShowDropdown, getStyle, getClasses, validateValue, addItem, addItemHandler, addItemToValue, deleteSelectedItem, toggleDropdown, blurInput, closeDropdown, BaseChip }
}

})